import { inject, Injectable } from '@angular/core';
import { map, share, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TESS_PARENT_PRIV, VoucherEntitlement } from '../models/enums';
import { GenericService } from './generic.service';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class TessService {
  private readonly genericService = inject(GenericService);
  private readonly loggingService = inject(LoggingService);

  public readonly isTessUser$ = this.genericService
    .genericGetCall<Record<string, string[]>>(environment.ews_userinfo_url + '?cache=short')
    .pipe(
      tap((response) => this.loggingService.log(`EWS Userinfo response: ${JSON.stringify(response)}`)),
      map((response) => {
        const entitlements: string[] = [];
        for (const [key, value] of Object.entries(response)) {
          if (Array.isArray(value) && value.length > 0) {
            if (value.includes('use')) {
              entitlements.push(key);
            }
          }
        }
        this.loggingService.log(`Final tess user extracted entitlements: ${entitlements}`);
        return (
          entitlements &&
          (entitlements.includes(VoucherEntitlement.NASDAPRIV_VOUCHER) || entitlements.includes(TESS_PARENT_PRIV))
        );
      }),
    );
}
